
import {amountFormatter} from '../Common/util';

// Measure 목록
export const measureColumnData = [
    {
        title: '분류',
        dataIndex: 'measure_type',
        key: 'measure_type',
        width: '70px',
        align: 'center',
        ellipsis : false,
        editable: false,
        sorter: {
            compare: (a, b) => a.measure_type.localeCompare(b.measure_type),
        },
    },
    {
        title: '진단코드',
        dataIndex: 'measure_cd',
        key: 'measure_cd',
        width: '100px',
        align: 'center',
        ellipsis : false,
        editable: false,
        sorter: {
            compare: (a, b) => a.measure_cd.localeCompare(b.measure_cd),
        },
    },
    {
        title: '진단항목',
        dataIndex: 'measure_nm',
        key: 'measure_nm',
        width: '250px',
        align: 'left',
        ellipsis : false,
        editable: false,
    },
    {
        title: '중요도',
        dataIndex: 'important_grd',
        key: 'important_grd',
        width: '70px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.important_grd.localeCompare(b.important_grd),
        },
    },
    {
        title: '위협코드',
        dataIndex: 'threat_cd',
        key: 'threat_cd',
        width: '70px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.threat_cd.localeCompare(b.threat_cd),
        },
    },
    {
        title: '구축비용 기준',
        dataIndex: 'cost_measure',
        key: 'cost_measure',
        width: '60px',
        align: 'center',
        editable: false,
    },
    {
        title: '위험도 기준',
        dataIndex: 'risk_measure',
        key: 'risk_measure',
        width: '50px',
        align: 'center',
        editable: false,
    },
    {
        title: '난이도 기준',
        dataIndex: 'difficulty_measure',
        key: 'difficulty_measure',
        width: '50px',
        align: 'center',
        editable: false,
    },
    {
        title: '합계',
        dataIndex: 'sum_measure',
        key: 'sum_measure',
        width: '70px',
        align: 'center',
        render: (_ , rowData ) => {
            return (
                amountFormatter(Number(rowData.cost_measure) + Number(rowData.risk_measure) + Number(rowData.difficulty_measure))
            );
        },
    },
    {
        title: '적용시기',
        dataIndex: 'apply_time',
        key: 'apply_time',
        width: '70px',
        align: 'center',
        editable: false,
    },
    {
        title: '대응전략',
        dataIndex: 'apply_action',
        key: 'apply_action',
        width: '70px',
        align: 'center',
        editable: false,
    },
];



// Suggest 목록
export const suggestColumnData = [
    {
        title: '진단코드',
        dataIndex: 'measure_cd',
        key: 'measure_cd',
        width: '70px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.measure_cd.localeCompare(b.measure_cd),
        },
    },
    // {
    //     title: '자산유형',
    //     dataIndex: 'asset_spec',
    //     key: 'asset_spec',
    //     width: '70px',
    //     align: 'center',
    //     editable: false,
    //     sorter: {
    //         compare: (a, b) => a.asset_spec.localeCompare(b.asset_spec),
    //     },
    // },
    {
        title: '권고사항 내용',
        dataIndex: 'suggest_desc',
        key: 'suggest_desc',
        width: '500px',
        align: 'left',
        ellipsis : false,
        editable: false,
        render: (text) => (
          <span dangerouslySetInnerHTML={{ __html: text }} />
        ),
    },
];


// Risk 목록
export const riskColumnData = [
    // {
    //     title: '진단코드',
    //     dataIndex: 'measure_cd',
    //     key: 'measure_cd',
    //     width: '70px',
    //     align: 'center',
    //     editable: false,
    //     sorter: {
    //         compare: (a, b) => a.measure.localeCompare(b.measure),
    //     },
    // },
    {
        title: '위험코드',
        dataIndex: 'risk_cd',
        key: 'risk_cd',
        width: '70px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.measure.localeCompare(b.measure),
        },
    },
    {
        title: '위험시나리오',
        dataIndex: 'risk_desc',
        key: 'risk_desc',
        width: '500px',
        align: 'left',
        ellipsis : false,
        editable: false,
    },
];


// Corrective 목록
export const correctiveColumnData = [
    {
        title: '자산코드',
        dataIndex: 'asset_cd',
        key: 'asset_cd',
        width: '100px',
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => (a.asset_cd || '').localeCompare(b.asset_cd || ''),
        },
    },
    {
        title: '진단코드',
        dataIndex: 'measure_cd',
        key: 'measure_cd',
        width: '100px',
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => a.measure_cd.localeCompare(b.measure_cd),
        },
    },
    {
        title: '상태',
        dataIndex: 'current_status',
        key: 'current_status',
        width: '60px',
        align: 'left',
        ellipsis : false,
        editable: true,
    },
    {
        title: '점검결과',
        dataIndex: 'result_cd',
        key: 'result_cd',
        width: '50px',
        align: 'left',
        ellipsis : false,
        editable: true,
    },
    {
        title: '현황',
        dataIndex: 'corrective_desc',
        key: 'corrective_desc',
        width: '500px',
        align: 'left',
        ellipsis : false,
        editable: true,
    },
];

// Threat 목록
export const threatColumnData = [
    {
        title: '분류',
        dataIndex: 'threat_type',
        key: 'threat_type',
        width: '70px',
        align: 'center',
        ellipsis : false,
        fixed : false,
        sorter: {
            compare: (a, b) => a.threat_type.localeCompare(b.threat_type),
        },
    },
    {
        title: '위협코드',
        dataIndex: 'threat_cd',
        key: 'threat_cd',
        width: '70px',
        align: 'center',
        ellipsis : false,
        fixed : false,
        sorter: {
            compare: (a, b) => a.threat_cd.localeCompare(b.threat_cd),
        },
    },
    {
        title: '위협 항목',
        dataIndex: 'threat_nm',
        key: 'threat_nm',
        width: '150px',
        align: 'left',
        ellipsis : false,
        fixed : false,
        sorter: {
            compare: (a, b) => a.threat_nm.localeCompare(b.threat_nm),
        },
    },
    {
        title: '내용',
        dataIndex: 'threat_desc',
        key: 'threat_desc',
        width: '300px',
        align: 'left',
        ellipsis : false,
        sorter: {
            compare: (a, b) => a.threat_desc.localeCompare(b.threat_desc),
        },
    },
    {
        title: '위협강도',
        dataIndex: 'strength_grd',
        key: 'strength_grd',
        width: '60px',
        align: 'center',
    },
    {
        title: '발생빈도',
        dataIndex: 'frequency_grd',
        key: 'frequency_grd',
        width: '60px',
        align: 'center',
    },
    {
        title: '위협강도(점수)',
        dataIndex: 'strength_score',
        key: 'strength_score',
        width: '60px',
        align: 'center',
    },
    {
        title: '발생빈도(점수)',
        dataIndex: 'frequency_score',
        key: 'frequency_score',
        width: '60px',
        align: 'center',
    },
    {
        title: '위협평가점수표',
        dataIndex: 'threat_score',
        key: 'threat_score',
        width: '60px',
        align: 'center',
    },
    {
        title: '위협등급',
        dataIndex: 'threat_grd',
        key: 'threat_grd',
        width: '60px',
        align: 'center',
    },
    {
        title: '위협등급(점수)',
        dataIndex: 'threat_grd_score',
        key: 'threat_grd_score',
        width: '60px',
        align: 'center',
    },
];

